import dayjs, { Dayjs } from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayOfYear from 'dayjs/plugin/dayOfYear';
import isoWeek from 'dayjs/plugin/isoWeek';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import weekday from 'dayjs/plugin/weekday';
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(dayOfYear);
dayjs.extend(isoWeek);
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(weekday);
export const shopTimeZone = 'America/Los_Angeles';
export function today(zone = shopTimeZone) {
    return dayjs().tz(zone).startOf('day');
}
dayjs.tz.setDefault(shopTimeZone);
function range(start, end, stepValue = 1, stepUnit, inclusiveEnd, format) {
    const cond = inclusiveEnd ? () => !start.isAfter(end) : () => start.isBefore(end);
    if (format) {
        const values = [];
        while (cond()) {
            values.push(start.format(format));
            start = start.add(stepValue, stepUnit);
        }
        return values;
    }
    const values = [];
    while (cond()) {
        values.push(start);
        start = start.add(stepValue, stepUnit);
    }
    return values;
}
export { dayjs, Dayjs, range };
